<template>
  <div>
    <!-- Trigger Button -->
    <v-btn 
      :disabled="buttonDisabled" 
      text
      dark
      :loading="loading" 
      @click="fetch" 
      class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
    >
      <v-icon left size="16">fas fa-file-export</v-icon>
      Exportar
    </v-btn>

    <!-- Download Dialog -->
    <v-dialog v-model="dataReady" max-width="400" transition="scale-transition">
      <v-card class="modern-card overflow-hidden rounded-xl">
        <!-- Premium Header -->
        <div class="bg-grey-light pa-6 border-bottom">
          <div class="d-flex align-center">
            <v-avatar color="primary" size="40" class="mr-4 shadow-sm border-white-sm">
              <v-icon color="white" small>fas fa-download</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 font-weight-black primary--text lh-1">Exportar Planificación</div>
              <div class="caption grey--text font-weight-bold text-uppercase tracking-wider mt-1">Archivo CSV preparado</div>
            </div>
          </div>
        </div>

        <v-card-text class="text-center pa-8">
          <v-avatar color="primary lighten-5" size="80" class="mb-6">
            <v-icon color="primary" size="40">fas fa-stream</v-icon>
          </v-avatar>
          <div class="body-1 primary--text font-weight-bold mb-2">¡Datos procesados!</div>
          <div class="caption grey--text px-4 mb-6">La secuencia de planificación ha sido exportada exitosamente.</div>

          <vue-json-to-csv
            :json-data="secuenceData"
            :labels="labels"
            :csv-title="csvTitle"
            :separator="';'"
            @success="val => handleSuccess(val)"
            @error="val => handleError(val)">
            <v-btn 
              color="success" 
              block 
              large 
              elevation="0"
              height="48"
              class="font-weight-black text-none rounded-lg shadow-sm"
            >
              <v-icon left>fas fa-download</v-icon>
              Descargar CSV
            </v-btn>
          </vue-json-to-csv>
        </v-card-text>

        <v-divider class="mx-8 opacity-10"></v-divider>
        <div class="pa-4 text-center">
          <v-btn text small color="grey" class="text-none font-weight-bold" @click="dataReady = false">Cerrar</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import VueJsonToCsv from 'vue-json-to-csv'
import numeral from 'numeral'
import moment from 'moment'
export default {
  name:"ExportMachinePlanner",
  props:['secuence','options','disabled','machine'],
  components: {VueJsonToCsv,},
  data() {
    return {
      loading: false,
      dataReady:false,
      labels:{ 
        secuence:{title:'Sec.'},
        orden:{title:'OT'},
        customer_name:{title:'Cliente'},
        //seller_name:{title:'Vendedor'},
        product:{title:'Producto'},
        name: { title: 'Proceso' },
        total:{title:'Total'},
        completed:{title:'Completado'},
        pending:{title:'Pendiente'},
        units:{title:'UN'},
        machine:{title:'Area'},
        equipmentAsigned_name:{title:'Equipo Asignado'},
        delivery_date:{title:'Fecha Entrega'},
        //install_date:{title:'Fecha Instalación'},
        //uninstall_date:{title:'Fecha Desinstalación'},
       },
       csvTitle:`export_planificación_${moment(new Date().toISOString()).format('DD-MM-yyyy_HH:mm')}`
    }
  },
  computed:{
    secuenceData(){
      return this.secuence.map(i=>{
        return {
          secuence:this.secuence.indexOf(i)+1,
          orden:i.work_order,
          customer_name:i.customer_name,
          product:i.product_name,
          name:i.name,
          total:i.unit_m2?numeral(i.product_mts2).format('0[.]00'):numeral(i.product_qty).format('0[.]00'),
          completed:i.unit_m2?numeral(i.total_mts2).format('0[.]00'):numeral(i.total_qty).format('0[.]00'),
          pending:i.unit_m2?numeral(i.product_mts2-i.total_mts2).format('0[.]00'):numeral(i.product_qty-i.total_qty).format('0[.]00'),
          units:i.unit_m2?'MTS2':'UNID',
          machine:this.machine?.name,
          delivery_date:moment(i.delivery_date).format('DD-MM-YYYY'),
          install_date:"",//i.install_date?moment(i.install_date).format('DD-MM-YYYY'):'',
          uninstall_date:"",//i.uninstall_date?moment(i.uninstall_date).format('DD-MM-YYYY'):'',
          seller_name:"",//i.seller_name,
          equipmentAsigned_name:i.equipment_assigned//i.equipmentAsigned_name?i.equipmentAsigned_name:''
        }
      })
    },
    buttonDisabled(){
      return this.disabled
    },
  },
  methods:{
    async fetch(){
      this.dataReady=true
    },
    handleSuccess(val){
      console.log(val)
      notifications.showSuccess('Ordenes de Trabajo Exportadas')
      this.dataReady=false
    },
    handleError(val){
      console.log(val)
      notifications.showError('Error Exportando Ordenes de Trabajo')
      this.dataReady=false
    }
  }

}
</script>